import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FuncaoService } from '../funcao-service/funcao.service';
import { ListaBase } from '././../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from '././../../../../shared/gridview/EstruturaGridViewBuilder';

@Component({
  selector: 'app-funcao-lista',
  templateUrl: '../../template/lista.html',
  styleUrls: ['./funcao-lista.component.css']
})
export class FuncaoListaComponent
  extends ListaBase
  implements OnInit {
  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;

  constructor(service: FuncaoService, toastr: ToastrService, router: Router) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 5;
    this.exibirBotaoDetalhes = true;
  }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna('descricao', 'parametros.funcao.descricao')
      .build();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
      || this.filtros.descricao;
  }

}
